/**
 * It does the same as mobileReadMore function in read-more.js but in different way to make it work in Owl carousel
 */

export const toggleText = () => {
	const $ = jQuery;
	$( '.owl-carousel' ).on( 'click', '.mobile-read-more-switch p', function () {
		var targetElement = $( this ).parent().parent().find( '.wp-block-pik-read-more-text' );

		if ( targetElement.hasClass( 'mobile-read-more' ) ) {

			setTimeout( function () {
				targetElement.removeClass( 'mobile-read-more' );
			}, 100 );

			$( this ).parent().parent().hide().show( 0 );

			$( this ).parent().removeClass( 'show-content' );
			$( this ).parent().addClass( 'hide-content' );
		} else {

			setTimeout( function () {
				targetElement.addClass( 'mobile-read-more' );
			}, 100 );

			$( this ).parent().parent().hide().show( 0 );

			$( this ).parent().removeClass( 'hide-content' );
			$( this ).parent().addClass( 'show-content' );
		}
	} );
}